export default __webpack_public_path__ + "static/media/banner-shape.a0cef858.jpg";